import {
  browserName,
  browserVersion,
  isMobile,
  isTablet,
  osName,
  osVersion,
} from 'react-device-detect';

import type { T_DeviceData, T_Platform } from '@/types/Device';
import { E_DeviceType } from '@/types/Device';

export const isAppleDevice = () =>
  navigator.userAgent.match(/iPhone/i) ||
  navigator.userAgent.match(/iPad/i) ||
  navigator.userAgent.match(/iPod/i) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const getBrowser = (): T_Platform => {
  return { name: browserName, version: browserVersion };
};

export const getOperatingSystem = (): T_Platform => {
  return { name: osName, version: osVersion };
};

export const getDeviceType = (): E_DeviceType => {
  return isMobile ? E_DeviceType.MOBILE : isTablet ? E_DeviceType.TABLET : E_DeviceType.DESKTOP;
};

export const getDeviceData = () => {
  const deviceData: T_DeviceData = {
    browser: getBrowser(),
    deviceType: getDeviceType(),
    operatingSystem: getOperatingSystem(),
    userAgent: navigator.userAgent,
  };

  return deviceData;
};
